import { IEntity } from './entity';
import { ISupplierScheduleTask } from './supplier-schedule-task';
import { ISupplierScheduleTaskGroup } from './supplier-schedule-task-group';
import { ITagEntity } from './tag-entity';

/*
Represents the SupplierScheduleDTO entity
*/
export interface ISupplierSchedule extends IEntity {
  supplierName: string;
  status: string; // plated etc.
  area: string;
  postcode: string;
  telephone: string;
  distanceFromTask: number;
  tasks: ISupplierScheduleTask[][];
  groupedTasks: ISupplierScheduleTaskGroup[];
  supplierAvailabilityExceptions: ISupplierAvailabilityException[];
  supplierTasks?: ISupplierScheduleTask[];
  validity?: Date;
  supplierId?: number;
  fromDateTime?: Date;
  toDateTime?: Date;
  organisationContractTypeId?: number;
  supplierOperationalData: ISupplierOperationalData;
  availabilityOrder: number[];
  allocatedTimeMinutes: number[];
  allocatedTimeOrder: number[];
  tagEntities: ITagEntity[];
  isAvailable?: boolean[]; // calculated in front end per data of schedule
  availabilityState?: SupplierAvailabilityStateEnum[];
}

/*
Represents the SupplierAvailabilityInfoDTO entity
*/
export interface ISupplierAvailabilityInfo extends IEntity {
  supplierAvailabilityExceptions: ISupplierAvailabilityException[];
  supplierId: number;
}

export interface ISupplierAvailabilityException extends IEntity {
  exceptionDate: Date;
  availabilityState?: SupplierAvailabilityStateEnum;
}

export interface ISupplierScheduleSupplier extends IEntity {
  id: number;
  supplierName: string;
}

export interface ISupplierOperationalData extends IEntity {
  classification: string;
  totalJobs: number;
  jobsInLast30Days: number;
  completionRateLast30Days: number;
  completionRateAllJobs: number;
  lastUpdated: Date;
  isTransporter: boolean;
  hasTradePlate: boolean;
}

export enum SupplierAvailabilityStateEnum {
  unset = -1,
  unavailable = 0,
  available = 1,
  doNotDisturb = 2,
}
